export default "__VITE_ASSET__BfeLUOyS__"